//-- Break up an array into batches of x length -------------------------------
export const batchArray = <T>(arr: T[], len: number) => {
  const arrayBatches: T[][] = []
  let idx = 0

  const batchLength = Math.max(Math.ceil(len), 1)
  while (idx < arr.length) {
    arrayBatches.push(arr.slice(idx, batchLength + idx))
    idx += batchLength
  }

  return arrayBatches
}
